import {
    PLAN_TYPE_FREE,
    PLAN_TYPE_ONE_TIME,
    PLAN_TYPE_INSTALLMENT_PLAN
} from '../constants.js';

export default {
    methods: {
        formattedPrice(plan) {
            if (plan.type === PLAN_TYPE_FREE) {
                return this.trans('Free');
            }

            const formattedPrice = new Intl.NumberFormat(window.Kourses.locale, {style: 'currency', currency: plan.currency}).format(plan.price);
            const formattedSetupPrice = new Intl.NumberFormat(window.Kourses.locale, {style: 'currency', currency: plan.currency}).format(plan.setup_price);

            if (plan.type === PLAN_TYPE_ONE_TIME || (plan.type === PLAN_TYPE_INSTALLMENT_PLAN && plan.interval_count === 1)) {
                return formattedPrice;
            }

            const withSetupPrice = plan.setup_price !== null && plan.setup_price > 0
                ? this.trans(' with :price setup fee', {'price': formattedSetupPrice})
                : '';

            if (plan.type === PLAN_TYPE_INSTALLMENT_PLAN) {
                return this.trans(':price for :installments :interval:setup', {'price': formattedPrice, 'installments': plan.interval_count, 'interval': this.translateInterval(plan.interval, 'plural'), 'setup': withSetupPrice});
            }

            if (parseInt(plan.trial_period_days, 10)) {
                return this.trans(':price per :interval after :trial-day free trial:setup', {'price': formattedPrice, 'interval': this.translateInterval(plan.interval), 'trial': plan.trial_period_days, 'setup': withSetupPrice});
            }

            return this.trans(':price per :interval:setup', {'price': formattedPrice, 'interval': this.translateInterval(plan.interval), 'setup': withSetupPrice});
        },
    },
}
